import React, { Component } from 'react'
import intl from 'react-intl-universal'
// import { NavLink } from 'react-router-dom'
import NavLink from '../components/LinkHack'
import PropTypes from 'prop-types'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import ResultsInnerExperienceInner from './ResultsInnerExperience'
import shortid from 'shortid'

// TODO: Check `Results.js` component usage, maybe we need use subcomponents for every result group instead
@inject('wishlist', 'user')
@observer
class ResultsInner extends Component {
  constructor(props) {
    super(props)

    let { user, categories, categoryId } = props
    let token = user.token
    console.log('ResultsInner.js - constructor() - token', token)

    if (token) {
      this.props.wishlist.get(token)
    }

    // If category ID provided, show only this category
    if (categoryId && categories && categories.length > 0) {
      categories = [categories.find(obj => {
        console.log('ResultsInner.js - constructor() - category ID provided', obj.id.toString() === categoryId.toString())
        return obj.id.toString() === categoryId.toString()
      })]
      console.log('ResultsInner.js - constructor() - categories', categories)
    }

    this.state = {
      categories
    }
  }

  render () {
    let {
      categoryId,
      excludeIds,
      showCategoryLinks,
      maxCategories,
      maxCategoryExperiences,
      wishlist,
      user
    } = this.props
    let {categories} = this.state
    console.log('ResultsInner.js - render() - wishlist', wishlist)
    console.log('ResultsInner.js - render() - user', user)
    console.log('ResultsInner.js - render() - categories', categories)
    console.log('ResultsInner.js - render() - showCategoryLinks', showCategoryLinks)

    const get_experiences = (experiences) => {
      console.log('ResultsInner.js - render() - get_experiences - excludeIds', excludeIds)
      console.log('ResultsInner.js - render() - get_experiences - excludeIds', excludeIds)
      console.log('ResultsInner.js - render() - get_experiences - experiences', experiences)
      // Exclude IDs
      if (Array.isArray(excludeIds) && excludeIds.length > 0) {
        experiences = experiences.filter(x => !~excludeIds.indexOf(x.id.toString()))
      }
      console.log('ResultsInner.js - render() - get_experiences - experiences2', experiences)

      return experiences.slice(0, maxCategoryExperiences)
    }

    if (!user.login) {
      wishlist = null
    }

    if (!categories) {
      return (<div />)
    }

    return (
      <section className={'b-experiences b-experiences_' + this.props.type}>
        {categories.length > 0 &&
        categories.slice(0, maxCategories).map((group, groupIndex) =>
          <div className='b-experiences-group' key={shortid.generate()}>
            <div className='b-experiences-group-inner'>
              {showCategoryLinks &&
              <div className='b-experiences-group-header'>
                <NavLink to={'/category/' + group.id}
                      className='b-experiences-group-header-title'>
                  {group.description}
                </NavLink>
                <NavLink to={'/category/' + group.id}
                      className='b-experiences-group-header-link'>{intl.get('View all')}</NavLink>
              </div>}
              {!showCategoryLinks &&
              <div className='b-experiences-group-header'>
                <div className='b-experiences-group-header-title'>
                  {group.description}
                </div>
              </div>}
              {group.experiences.length > 0 &&
              <div className='b-experiences-group-container'>
                {get_experiences(group.experiences).map(experience =>
                  <ResultsInnerExperienceInner experience={experience}
                                               key={shortid.generate()}
                                               wishlist={wishlist} />
                )}
              </div>}
              {(group.experiences.length <= 0) &&
              <div className='b-empty'><div className='b-empty-text'>{intl.get('experiences.no_experiences_in_category')}</div></div>}
            </div>
          </div>
        )}
      </section>
    )
  }
}

ResultsInner.defaultProps = {
  type: 'horizontal'
}

ResultsInner.propTypes = {
  type: PropTypes.string,
  categoryId: PropTypes.string,
  excludeIds: PropTypes.array,
  showCategoryLinks: PropTypes.bool,
  maxCategories: PropTypes.number,
  maxCategoryExperiences: PropTypes.number,
  categories: PropTypes.any,
  wishlist: MobxPropTypes.observableObject,
  user: MobxPropTypes.observableObject
}

export default ResultsInner



// WEBPACK FOOTER //
// ./src/components/ResultsInner.js